import React, { useState } from "react";
import InputField from "../../input-field/InputField";
import DefaultButton from "../../default-button/DefaultButton";
import Plus from "../../../assets/icons/Plus";
import CategoryTable from "../CategoriesTable/CategoryTable";
import { useHookstate } from "@hookstate/core";
import { onInputChangeNative, updateMiscState } from "../../../misc/utils";
import {
  accessGlobalMiscState,
  useGlobalMiscState,
} from "../../../stores/misc";
import { HasRole } from "../../HasRole";

export default function CategoryPage() {
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const searchQuery = state.searchQuery || "";

  const onClickAddCategory = () => {
    updateMiscState("socialTranscriptIsAddModalOpen")(true);
    accessGlobalMiscState().setBatch({
      socialTranscriptIsAddModalOpen: true,
      socialTranscriptCurrentCategory: null,
    });
  };

  return (
    <div className='bg-white py-2 px-4 rounded-xl w-full mt-4 h-screen'>
      <div className='flex justify-between items-center pl-2 pr-[22px] pt-2 pb-6'>
        <InputField
          type='text'
          additionalClassName='rounded-lg w-[360px] bg-valley-background-blue'
          placeholder='Поиск по категориям и пунктам'
          value={searchQuery}
          handleChange={onInputChangeNative(localState, "searchQuery")}
        />
        <HasRole roles={["create_social_transcript_categories"]}>
          <DefaultButton
            buttonText='Создать категорию'
            additionalStyle='text-[#3BBC30] border-1 border-[#3BBC30] py-2 px-6 font-bold'
            Icon={Plus}
            onClick={onClickAddCategory}
          />
        </HasRole>
      </div>
      <CategoryTable searchQuery={searchQuery} />
    </div>
  );
}
